import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSchemeList as _getSchemeList, deleteScheme } from 'api/payroll/pay-slip';
export default {
  data: function data() {
    return {
      loading: true,
      wageLength: -1,
      wageList: [] // 方案列表
    };
  },

  computed: {
    listLen: function listLen() {
      return this.wageList.length;
    }
  },
  mounted: function mounted() {
    this.$router.push({
      query: {
        active: '1'
      }
    });
    this.getSchemeList();
  },
  methods: {
    getSchemeList: function getSchemeList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 工资条列表
              _this.loading = true;
              _getSchemeList().then(function (res) {
                if (res && res.code === 1) {
                  _this.wageList = res.data;
                  _this.wageLength = res.data.length;
                }
              }).finally(function () {
                return _this.loading = false;
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    goToDetail: function goToDetail(item, state) {
      // 跳转配置页
      this.$router.push({
        path: '/payroll/edit-pay-slip/' + item.id,
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          payslip_scheme_id: item.id,
          state: state
        })
      });
    },
    delPayrollScheme: function delPayrollScheme(params, index) {
      var _this2 = this;
      // 删除工资条
      this.$confirm(this.$t('1087'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              deleteScheme({
                payslip_scheme_id: params.id
              }).then(function (res) {
                if (res && res.code === 1) _this2.getSchemeList();
                _this2.$message.success(_this2.$t('806'));
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function () {});
    }
  }
};